export const translate = (key) => (window.translationObject || {})[key] || key;
